import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    Snackbar,
    Alert,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    deleteDocument,
    Document,
    renameDocument,
} from "../../common/redux/documentsAction";

interface Props {
    open: boolean;
    document: Document | null;
    onClose: () => void;
    onSuccess?: () => void;
}

const DeleteModal: React.FC<Props> = ({
    open,
    document,
    onClose,
    onSuccess,
}) => {
    const [newName, setNewName] = useState("");
    const [error, setError] = useState<string | null>(null);

    const { t } = useTranslation();

    const remove = async () => {
        if (!document) return;
        try {
            await deleteDocument(document.id);
            onSuccess?.();
            onClose();
        } catch (error) {
            setError(t("manageDocuments.error.delete"));
            console.error("Error deleting document:", error);
        }
    };

    useEffect(() => {
        if (open) setNewName(document?.name || "");
    }, [open, document?.name]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t("manageDocuments.delete.modal.title")}</DialogTitle>
            <DialogContent>
                <Typography sx={{ mt: 2 }}>
                    {t("manageDocuments.delete.modal.body", {
                        name: document?.name || "",
                    })}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    {t("button.modal.cancel")}
                </Button>
                <Button
                    onClick={() => remove()}
                    variant="contained"
                    color="primary"
                >
                    {t("button.modal.valid")}
                </Button>
            </DialogActions>

            <Snackbar
                open={!!error}
                autoHideDuration={3000}
                onClose={() => setError(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert
                    onClose={() => setError(null)}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                    {error}
                </Alert>
            </Snackbar>
        </Dialog>
    );
};

export default DeleteModal;
